export const DEFAULT_COMPETITION_TYPE = 'MATHS_TALENTS';
export const EXAM_LEVEL_TYPE = [{
    id: 'MATHS_TALENTS_1',
    label: '丘成桐少年班',
}, {
  id: 'MATHS_TALENTS_2',
  label: '丘成桐少年班选拔',
}];
export const EXAM_LEVEL_TYPE_ENUM = {
    MATHS_TALENTS_1: '丘成桐少年班',
    MATHS_TALENTS_2: '丘成桐少年班选拔',
}
export const QuestionTypeMap = {
  'TEXT_CHOICE_QUESTION':'单选题',
  'PICTURE_BLANK_FILLING': '填空题',
  'PICTURE_PROOF': '问答题',
}
export const ROLE_MAP = {
    'ADMIN':'管理员',
    'TEACHER':'老师',
    'STUDENT':'学生',
}

export const CHECK_STATUS_MAP = {
  0:{
    label:'待批改',
    style:'un-check'
  },
  1: {
    label:'批改中',
    style:'checking'
  },
  2:{
    label:'成绩已核对',
    style:'checked'
  }
}

export const USER_GRADE_MAP = [
    { label: '小学前', value: '小学前' },
    { label: '小学', value: '小学' },
    { label: '初一', value: '初一' },
    { label: '初二', value: '初二' },
    { label: '初三', value: '初三' },
    { label: '高一', value: '高一' },
    { label: '高二', value: '高二' },
    { label: '高三', value: '高三' },
    { label: '大学及以上', value: '大学及以上' },
]

export const CheatTypeList = [
  { label: '疑似离开了', value: 'scenePersonExit' },
  { label: '画面疑似有多个人', value: 'manyPeople' },
  { label: '疑似起立', value: 'actionPoseStandup' },
  { label: '疑似频繁点头', value: 'headUpDown' },
  { label: '疑似频繁转头/摇头', value: 'headShaking' },
  { label: '疑似戴手表', value: 'watch' },
  { label: '疑似戴耳机', value: 'earPhone' },
  { label: '疑似打电话', value: 'cellPhone' },
  { label: '疑似现场有人说话', value: 'actionPersonSpeech' },
  { label: '疑似举手', value: 'actionPoseHandup' },
  // 新增页面状态检测类型
  { label: '疑似切换页面', value: 'pageHidden'},
  { label: '疑似页面失焦', value: 'pageBlur'},
  { label: '疑似鼠标离开', value: 'mouseLeave'},

]